import { FaqItem, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getFAQbyId = async (
  groupId: number,
  faqId: string,
  locale: string
): Promise<FaqItem | null> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.FrequentlyAskedQuestions}/id/${faqId}?marketLocale=${encodeURIComponent(locale)}`;

    const response = await knowledgeBaseHttp.get<FaqItem>(url);
    return response?.data || null;
  } catch (error) {
    throw new Error(`Error fetching FAQ: ${error}`);
  }
};
